// var languageType = require('./languageCommon.js')
var languageType = require('./languageCommon.js')
var language = localStorage.getItem('language') || 'zh-CN'
if(language=='USA'){
    $('.joinrz').css('margin-top','4px')
    $('.joinrz').css('font-size','18px')
}
if(language=='zh-CN'){
    document.getElementsByTagName('meta')[1].setAttribute('content',franchmeta[language])
    document.getElementsByTagName('meta')[2].setAttribute('content',franchkey[language])
    document.title = franchtitle[language];
}else{
    document.getElementsByTagName('meta')[1].setAttribute('content',franchmeta['USA'])
    document.getElementsByTagName('meta')[2].setAttribute('content',franchkey['USA'])
    document.title = franchtitle['USA'];
    // document.getElementsByTagName('title')[1].setAttribute('content',grouptitle['USA'])
}
$('.commonlanguage').html(commonlanguage[language])
$('title').html(joinUsTitle[language]);
$('.commonHomePage').html(commonHomePage[language]);
$('.commonLvyue').html(commonLvyue[language]);
$('.commonAboutLvyue').html(commonAboutLvyue[language]);
$('.commonlvyueBrand').html(commonlvyueBrand[language]);
$('.commonFlowerConstruction').html(commonFlowerConstruction[language]);
$('.commonFloralLux').html(commonFloralLux[language]);
$('.commonClaim').html(commonClaim[language]);
$('.commonWeiLai').html(commonWeiLai[language]);
$('.commonTanChen').html(commonTanChen[language]);
$('.commonJtc').html(commonJtc[language]);
$('.commonJtcDes').html(commonJtcDes[language]);
$('.commonBainaDes').html(commonBainaDes[language]);
$('.commonBanlanDes').html(commonBanlanDes[language]);

$('.commonflowerTravel').html(commonflowerTravel[language]);
$('.commonJoinInCooperation').html(commonJoinInCooperation[language]);
$('.commonPanorama').html(commonPanorama[language]);
// $('.commonPaidInformation').html(commonPaidInformation[language]);
$('.commonZh').html(commonZh[language]);
$('.commonUsa').html(commonUsa[language]);
$('.commonJp').html(commonJp[language]);
$('.commonKo').html(commonKo[language]);
$('.commonTh').html(commonTh[language]);
$('.commonYh').html(commonYh[language]);

$('.wzJoin').html(wzJoin[language]);
$('.wzTelephone').html(wzTelephone[language]);

$('.commonReservations a').html(commonReservations[language]);
$('.commonClose').html(commonClose[language]);
$('.commonFreebooking').html(commonFreebooking[language]);
$('.commonDownload').html(commonDownload[language]);
$('.commonWechatSubscription').html(commonWechatSubscription[language]);
$('.commonHuazhuSubscription').html(commonHuazhuSubscription[language]);
$('.commonBrandintroductio').html(commonBrandintroductio[language]);
$('.commonWantJoin').html(commonWantJoin[language]);
$('.commonConectUs').html(commonConectUs[language]);
$('.commonCustomerServiceHotline').html(commonCustomerServiceHotline[language]);
$('.commonConectChina').html(commonCustomerServiceHotlineChina[language]);
$('.commonConectPhilippines').html(commonCustomerServiceHotlinePhilippines[language]);
$('.commonConectJapan').html(commonCustomerServiceHotlineJapan[language]);
$('.commonConectKorea').html(commonCustomerServiceHotlineKorea[language]);
$('.commonConectThailand').html(commonCustomerServiceHotlineThailand[language]);
$('.commonConectYh').html(commonCustomerServiceHotlineYh[language]);
$('.commonCompanyInfo').html(commonCompanyInfo[language]);
$('.commonCompanyBeianInfo').html(commonCompanyBeianInfo[language]);
$('.commonCompanyBeianText').html(commonCompanyBeianText[language]);
$('.commonCompanyLicense').html(commonCompanyLicense[language]);
$('.commonCompanyICP').html(commonCompanyICP[language]);
$('.joinUsDreamofgoldnuggets').html(joinUsDreamofgoldnuggets[language]);
$('.homePageSwiperFiveJointheInformation').html(homePageSwiperFiveJointheInformation[language]);
$('.homePageSwiperFiveGirl').html(homePageSwiperFiveGirl[language]);
$('.homePageSwiperFiveBoy').html(homePageSwiperFiveBoy[language]);
$('.homePageSwiperFiveInputPhone').attr('placeholder',joinUsInputPhone[language]);
$('.homePageSwiperFiveInputPhone').attr('datavalue',joinUsInputPhone[language]);
$('.homePageSwiperFiveInputAddress').attr('placeholder',joinUsInputAddress[language]);
$('.homePageSwiperFiveInputAddress').attr('datavalue',joinUsInputAddress[language]);
$('.homePageSwiperFiveInputSpace').attr('placeholder',homePageSwiperFiveInputSpace[language]);
$('.homePageSwiperFiveInputSpace').attr('datavalue',homePageSwiperFiveInputSpace[language]);
$('.homePageSwiperFiveJoin').html(homePageSwiperFiveJoin[language]);
$('.homePageSwiperFiveMaterialcooperation').html(homePageSwiperFiveMaterialcooperation[language]);
$('.homePageSwiperFiveJoinRemarkTips').attr('placeholder',joinUsInputRemarkTip[language]);
$('.homePageSwiperFiveJoinRemarkTips').attr('datavalue',joinUsInputRemarkTip[language]);
$('.homePageSwiperFiveInputName').attr('placeholder',joinUsInputName[language]);
$('.homePageSwiperFiveJoinRemarkTips').attr('datavalue',joinUsInputRemarkTip[language]);
$('.homePageSwiperFiveInputName').html(joinUsInputName[language]);
$('.homePageSwiperFiveJoinLvyue').html(joinUsConsultation[language]);
$('.homePageSwiperFiveJoinInfo').html(joinUsConsultationWrap[language]);
$('.commonLvyue1').html(commonLvyue1[language]);
$('.Leadership').html(Leadership[language]);
$('.TalentRecruitment').html(TalentRecruitment[language]);
$('.subhtml').html(subhtml[language]);


$('.joinTitle').html(joinTitle[language]);
$('.joinContent').html(joinContent[language]);
$('.joinTitle22').html(joinTitle22[language]);
$('.joinContent22').html(joinContent22[language]);
$('.joinTitle33').html(joinTitle33[language]);
$('.joinContent33').html(joinContent33[language]);
$('.joinTitle44').html(joinTitle44[language]);
$('.joinContent44').html(joinContent44[language]);
$('.joinTitle55').html(joinTitle55[language]);
$('.joinContent55').html(joinContent55[language]);

$('.joinUsInputNameTitle').html(joinUsInputNameTitle[language]);
$('.joinUsInputPhoneTitle').html(joinUsInputPhoneTitle[language]);
$('.joinUsInputAddressTitle').html(joinUsInputAddressTitle[language]);
$('.joinUsInputRemarkTipTitle').html(joinUsInputRemarkTipTitle[language]);
$('.joinUsJoinTelephone').html(joinUsJoinTelephone[language]);

$('.intenails').html(intenails[language]);
$('.dobuemai').html(dobuemai[language]);

$('.joinUsInputJoinMsg').html(joinUsInputJoinMsg[language]);
$('.joinUsStep').html(joinUsStep[language]);
$('.joinUsHonor2019Title').html(joinUsHonor2019Title[language]);
$('.joinUsHonor2018Title').html(joinUsHonor2018Title[language]);
$('.joinUsHonor2017Title').html(joinUsHonor2017Title[language]);
$('.joinUsTel').html(joinUsTel[language]);
$('.freePhone').html(freePhone[language]);
$('.joinrz').html(joinrz[language]);
$('.joinUsHonor201901').html(joinUsHonor201901[language]);
$('.joinUsHonor201902').html(joinUsHonor201902[language]);
$('.joinUsHonor201903').html(joinUsHonor201903[language]);
$('.joinUsHonor201801').html(joinUsHonor201801[language]);
$('.joinUsHonor201802').html(joinUsHonor201802[language]);
$('.joinUsHonor201701').html(joinUsHonor201701[language]);
$('.joinUsHonorTitle').html(joinUsHonorTitle[language]);

$('.joinUsHonorTitle').html(joinUsHonorTitle[language]);
$('.flowerBuildingaboutfbType1').html(joinUs_brandDescFloral[language]);
$('.commonVylukDes').html(joinUs_brandDescVyluk[language]);
$('.commonVyluk').html(commonVyluk[language]);
$('.commonSuoxingDes').html(joinUs_brandDescSuoxing[language]);
$('.commonRealShot').html(commonRealShot[language]);
$('.franchiseAdvantage').html(franchiseAdvantage[language]);
$('.joinUs_brandTitle').html(joinUs_brandTitle[language]);
$('.joinUsIntroduce1').html(joinUsIntroduce1[language]);
$('.joinUsIntroduce2').html(joinUsIntroduce2[language]);
$('.joinUsIntroduce3').html(joinUsIntroduce3[language]);
$('.joinUsCommonWantUs').html(joinUsCommonWantUs[language]);
$('.joinUsDescribe').html(joinUsDescribe[language]);
$('.joinUsTitleH1').html(joinUsTitleH1[language]);
$('.joinUs_ad1Title').html(joinUs_ad1Title[language]);
$('.joinUs_ad1Des').html(joinUs_ad1Des[language]);
$('.joinUs_ad2Title').html(joinUs_ad2Title[language]);
$('.joinUs_ad2Des').html(joinUs_ad2Des[language]);
$('.joinUs_ad3Title').html(joinUs_ad3Title[language]);
$('.joinUs_ad3Des').html(joinUs_ad3Des[language]);
$('.joinUs_ad4Title').html(joinUs_ad4Title[language]);
$('.joinUs_ad4Des').html(joinUs_ad4Des[language]);
$('.joinUs_ad5Title').html(joinUs_ad5Title[language]);
$('.joinUs_ad5Des').html(joinUs_ad5Des[language]);
$('.joinUs_ad6Title').html(joinUs_ad6Title[language]);
$('.joinUs_ad6Des').html(joinUs_ad6Des[language]);
$('.joinUs_ad7Title').html(joinUs_ad7Title[language]);
$('.joinUs_ad7Des').html(joinUs_ad7Des[language]);
$('.joinUs_ad8Title').html(joinUs_ad8Title[language]);
$('.joinUs_ad8Des').html(joinUs_ad8Des[language]);
$('.joinUs_disclaimer').html(joinUs_disclaimer[language]);
$('.floralReservation').html(floralReservation[language]);
$('.commonBaina').html(commonBaina[language]);
$('.commonBanlan').html(commonBanlan[language]);
$('.commonBeuDes').html(commonBeuDes[language]);



/** WEBPACK FOOTER **
 ** ./src/js/joinUsLanguage.js
 **/